import {Component} from "react";
import React from "react";

class TopBar extends Component {
    constructor(props) {
        /*
            Props:
             - logout
         */
        super(props);

    }


    render() {
        return (
            <header className="topbar" data-navbarbg="skin5">
                <nav className="navbar top-navbar navbar-expand-md navbar-dark">
                    <div className="navbar-header" data-logobg="skin5">
                        <a className="nav-toggler waves-effect waves-light d-block d-md-none" href="javascript:void(0)"><i
                            className="ti-menu ti-close"></i></a>
                        <a className="navbar-brand" style={{
                            paddingLeft: "6px"
                        }}>
                            <b className="" style={{
                                fontSize:'28px',
                                color: 'rgb(109, 163, 207)'
                            }}>
                                Qib
                            </b>
                            <span className="logo-text" style={{
                                fontSize:'28px',
                                color: 'rgb(109, 163, 207)'
                            }}>
                                account
                            </span>
                        </a>

                        <a className="topbartoggler d-block d-md-none waves-effect waves-light"
                           href="javascript:void(0)" data-toggle="collapse" data-target="#navbarSupportedContent"
                           aria-controls="navbarSupportedContent" aria-expanded="false"
                           aria-label="Toggle navigation"><i className="ti-more"></i></a>
                    </div>

                    <div className="navbar-collapse collapse" id="navbarSupportedContent" data-navbarbg="skin5">
                        <ul className="navbar-nav float-left mr-auto">
                            <li className="nav-item d-none d-md-block"><a
                                className="nav-link sidebartoggler waves-effect waves-light" href="javascript:void(0)"
                                data-sidebartype="mini-sidebar"><i className="mdi mdi-menu font-24"></i></a></li>
                        </ul>
                        <ul className="navbar-nav float-right">
                            <li className="nav-item dropdown">
                                <a onClick={this.props.logout} className="nav-link waves-effect waves-dark pro-pic" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="mdi mdi-exit-to-app" style={{
                                    fontSize: '28px'
                                }}/></a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}

export default TopBar;